// src/components/NavLink.tsx
import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";
import React, { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { useSidebar } from "@/components/ui/sidebar";

interface NavLinkCompatProps extends Omit<NavLinkProps, "className" | "onClick"> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  (
    {
      className,
      activeClassName,
      pendingClassName,
      to,
      onClick,
      ...props
    },
    ref
  ) => {
    const { toggleSidebar } = useSidebar();

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
      // 先执行外面传进来的 onClick（如果有）
      if (onClick) {
        onClick(event);
      }
      if (event.defaultPrevented) return;

      // 只有在手机宽度时自动把 sidebar 收起来
      if (typeof window !== "undefined" && window.innerWidth < 768) {
        toggleSidebar();
      }
    };

    return (
      <RouterNavLink
        ref={ref}
        to={to}
        onClick={handleClick}
        className={({ isActive, isPending }) =>
          cn(
            className,
            isActive && activeClassName,
            isPending && pendingClassName
          )
        }
        {...props}
      />
    );
  }
);

NavLink.displayName = "NavLink";

export { NavLink };
